// src/hooks/useAuth.js
import { useState, useCallback } from "react";
import { api_path } from "../shared.js";

const BASE        = `${api_path}/user/user_auth.php`;
const AUTH_TOKEN  = process.env.REACT_APP_API_TOKEN || "";

const headers = {
  "Content-Type":  "application/json",
  "Authorization": AUTH_TOKEN ? `Bearer ${AUTH_TOKEN}` : "",
};

async function apiFetch(url, options = {}) {
  const res  = await fetch(url, { credentials: "include", headers, ...options });
  const json = await res.json();
  if (!json.success) throw new Error(json.message ?? "API error");
  return json;
}

export function useAuth() {
  const [roles,       setRoles]       = useState([]);
  const [permissions, setPermissions] = useState([]);  // AUTH rows ของ role ที่เลือก
  const [userMenus,   setUserMenus]   = useState([]);  // menus ของ user ที่เลือก
  const [allMenus,    setAllMenus]    = useState([]);  // menus ทั้งหมด (จาก menu API)
  const [loading,     setLoading]     = useState(false);
  const [error,       setError]       = useState(null);

  const clearError = () => setError(null);

  // ── โหลด roles ทั้งหมด ───────────────────────────────────────────────────
  const fetchRoles = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch(`${BASE}?roles=1`);
      setRoles(res.data ?? []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // ── โหลด permissions ของ role ────────────────────────────────────────────
  const fetchPermissionsByRole = useCallback(async (roleId) => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch(`${BASE}?role_id=${roleId}`);
      setPermissions(res.data ?? []);
    } catch (e) {
      setPermissions([]);
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // ── โหลด menus ที่ user เห็น ─────────────────────────────────────────────
  const fetchUserMenus = useCallback(async (userId) => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch(`${BASE}?user_id=${userId}`);
      setUserMenus(res.data ?? []);
    } catch (e) {
      setUserMenus([]);
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // ── โหลด all menus (สำหรับ permission editor) ───────────────────────────
  const fetchAllMenus = useCallback(async () => {
    try {
      const res = await apiFetch(`${api_path}/menu/menu.php`);
      setAllMenus(res.data ?? []);
    } catch (e) {
      setError(e.message);
    }
  }, []);

  // ── bulk save permissions ─────────────────────────────────────────────────
  const bulkSave = useCallback(async (roleId, perms) => {
    const res = await apiFetch(`${BASE}?action=bulk_save`, {
      method: "POST",
      body:   JSON.stringify({ ROLE_ID: roleId, permissions: perms }),
    });
    return res;
  }, []);

  return {
    roles, permissions, userMenus, allMenus,
    loading, error, clearError,
    fetchRoles, fetchPermissionsByRole, fetchUserMenus, fetchAllMenus,
    bulkSave,
  };
}
